<template>
	<Row class="bg-white">
		<Container>
			<article
				v-if="post"
				class="post-178 page type-page status-publish entry"
			>
				<header class="legal-disclosure">
					<h1
						v-if="post.title"
						v-html="post && post.title"
						class="entry-title"
					></h1>
				</header>

				<div
					class="entry-content legal-disclosure"
					v-html="contentFormatter(post.content)"
				></div>
			</article>
		</Container>
	</Row>

	<Head>
		<Title v-if="metadata">{{ metadata?.title }}</Title>

		<Link
			rel="canonical"
			:href="config['current_hostname'].slice(0, -1) + $route.path"
		/>

		<Meta
			name="description"
			content="Last Revised: March 4, 2024 Nothing in this Privacy Statement may be construed to create any obligation for the Company beyond what is required by applicable law. California residents click here to access our California Consumer Protection Act (CCPA) Notice. This Privacy Statement (“Privacy Statement” or “Statement”) describes the practices of StocksToTrade.Com Inc. (“StocksToTrade,” “STT,”…"
		/>
	</Head>
</template>

<script setup>
import { load } from "cheerio";

const contentFormatter = (content) => {
	const $ = load(content, {
		decodeEntities: false, // Prevent HTML entity decoding
		xmlMode: false // Do not treat input as XML
	});

	// First convert h1 to h2
	$("h1").each(function () {
		$(this).replaceWith(
			$("<h2>")
				.html($(this).html())
				.attr("class", $(this).attr("class"))
				.addClass("converted-from-h1") // Add a class to mark that these were originally h1
		);
	});

	// Then convert original h2 to h3, excluding those just converted from h1
	$("h2")
		.not(".converted-from-h1")
		.each(function () {
			$(this).replaceWith(
				$("<h3>").html($(this).html()).attr("class", $(this).attr("class"))
			);
		});

	return $.html();
};

const config = useRuntimeConfig().public;

const cookiePolicyDataKey = "cookie-policy-page-data";

const { data: asyncDataResult } = useAsyncData(cookiePolicyDataKey, async () => {
	const results = await $fetch(
		`${config.hostname}wp-json/wp/v2/pages?slug=cookie-policy&_embed`
	);
	const page = results?.[0];
	if (page) {
		return {
			post: {
				title: page.title.rendered,
				content: page.content.rendered
			},
			metadata: page.yoast_head_json,
			yoast: page.yoast_head
		};
	}
	return {};
});

// Refs for post and metadata for template use
const post = computed(() => asyncDataResult.value?.post);
const metadata = computed(() => asyncDataResult.value?.metadata);

// Refactoring methods to functions
const head_schema_seo = () => {
	const experiment = Object.entries(metadata.value || {});
	return experiment.filter(([key]) =>
		["canonical", "schema_json"].includes(key)
	);
};

const head_seo = () => {
	const experiment = Object.entries(metadata.value || {});
	return experiment.filter(
		([key]) =>
			![
				"title",
				"robots",
				"canonical",
				"schema_json",
				"WordPressAuthor_YoastHeadJson_Schema_"
			].includes(key)
	);
};
</script>

<style lang="scss">
@use "../assets/legal-pages" as *;
</style>
